import {Component, OnInit} from '@angular/core';
import {ContactUsService} from '../contact-us.service';

@Component({
  selector: 'bb-contact-us-view',
  templateUrl: './contact-us-view.component.html',
  styleUrls: ['./contact-us-view.component.scss'],
  providers: [ContactUsService],
})
export class ContactUsViewComponent implements OnInit {
  constructor() {
  }

  ngOnInit() {
  }
}
